import ProductGrid from "../ProductGrid";
import withProps from "recompose/withProps";
import { useGlobalContent } from "../../hooks";

export default withProps(({ items }) => {
  const { fromPriceLabel } = useGlobalContent("general");

  return {
    items: items.map((item) => ({
      ...item,
      priceLabel: fromPriceLabel,
    })),
  };
})(ProductGrid);
